import { ref, watch } from 'vue'
import { useRequest } from '@/composables/useRequest.js'
import { useNotificacion } from '@/composables/useNotificaciones.js'
import { useStore } from '@/composables/store/useStore.js'
import router from '@/router'

export function useModelo (resourceRouter, dialogoMsg, formId, form) {
  const myForm = ref(null)
  const modelos = ref({ data: [], loading: false })
  const modelo = ref({ data: null, loading: false })
  const objectoForm = ref({ data: null, loading: false, tipo: '' })
  const resultado = ref({ data: null, tipo: '' })
  const uploads = ref({ data: [], progress: 0, loading: false })
  const files = ref({ files: [], loading: false, data: null, duplicados: [] })
  const { fnHttpToken, fnHttpFile, fnHttpTokenCustomer, fnHttpTokenDownload, fnInicializarRequest, fnHttpTokenDownloadContent, fnHttpTokenDownloadContentFile, fnHttpFileCustomer, request } = useRequest()
  const { fnError, fnSuccess } = useNotificacion()
  const store = useStore()

  const fnAll = () => {
    request.value.tipo = 'MODELOS'
    fnHttpToken('GET', resourceRouter, null, modelos, 1)
  }

  const fnId = (id) => {
    request.value.tipo = 'MODELO'
    if (id !== '') {
      modelo.value.data = null
      fnHttpToken('GET', resourceRouter + '/' + id, null, modelo, 1)
    }
  }

  const fnModel = (metodo, resourceRouterm, data, loading, isPrefix) => {
    request.value.tipo = 'MODELO'
    modelo.value.data = null
    fnHttpToken(metodo, resourceRouterm, data, loading, isPrefix)
  }

  const fnModels = (metodo, resourceRouterm, data, loading, isPrefix) => {
    request.value.tipo = 'MODELOS'
    modelos.value.data = []
    fnHttpToken(metodo, resourceRouterm, data, loading, isPrefix)
  }

  const fnDownload = (metodo, resourceRouterm, data, filename, loading, isPrefix) => {
    fnHttpTokenDownload(metodo, resourceRouterm, data, filename, loading, isPrefix)
  }

  const fnDownloadContent = (metodo, ruta, data, objecto, loading, isPrefix) => {
    fnHttpTokenDownloadContent(metodo, ruta, data, objecto, loading, isPrefix)
  }

  const fnDownloadContentFile = (metodo, ruta, data, objecto, loading, isPrefix, pNameFile) => {
    fnHttpTokenDownloadContentFile(metodo, ruta, data, objecto, loading, isPrefix, pNameFile)
  }

  const fnUpload = (metodo, resourceRouterm, data, progress, isPrefix) => {
    request.value.tipo = 'FILES'
    fnHttpFile(metodo, resourceRouterm, data, progress, isPrefix)
  }

  const fnUploadCustomer = (metodo, resourceRouterm, data, files, progress, isPrefix) => {
    request.value.tipo = 'FILES'
    fnHttpFileCustomer(metodo, resourceRouterm, data, files, progress, isPrefix)
  }

  const fnFileRemover = (metodo, resourceRouterm, data, progress, isPrefix) => {
    request.value.tipo = 'FILE REMOVER'
    fnHttpToken(metodo, resourceRouterm, data, progress, isPrefix)
  }

  const fnCustomer = (metodo, resourceRouterm, data, objecto, loading, isPrefix) => {
    fnHttpTokenCustomer(metodo, resourceRouterm, data, objecto, loading, isPrefix)
  }

  const fnValidar = async (pOpcion = 1) => {
    myForm.value.validate().then(success => {
      if (success) {
        if (pOpcion === 1) {
          dialogoMsg.value.preguntar = true
        } else if (pOpcion === 2) { // enviar los dtos del consecutivo
          dialogoMsg.value.preguntar = true
        }
      } else {
        fnError('DEBE DILIGENCIAR LOS DATOS OBLIGATORIOS', 'top')
      }
    })
  }

  const fnSinValidar = () => {
    dialogoMsg.value.preguntar = true
  }

  const fnSinPreguntar = (isPrefix) => {
    guardar('GUARDAR SIN MENSAJE', dialogoMsg, isPrefix)
  }

  const fnMensajes = (accion, dialogoMsg, isPrefix) => {
    if (accion === 'PREGUNTAR ACEPTAR') {
      dialogoMsg.value.preguntar = false
      if (formId.value.id === 0) {
        guardar('GUARDAR', dialogoMsg, isPrefix)
      } else {
        modificar(dialogoMsg, isPrefix)
      }
    } else if (accion === 'PREGUNTAR ACEPTAR CONSECUTIVO') {
      guardar('GUARDAR - CONSECUTIVO', dialogoMsg, isPrefix)
    } else if (accion === 'PREGUNTAR CANCELAR') {
      dialogoMsg.value.preguntar = false
    } else if (accion === 'ELIMINAR ACEPTAR') {
      anular(dialogoMsg, 1)
      dialogoMsg.value.anular = false
    } else if (accion === 'ELIMINAR CANCELAR') {
      dialogoMsg.value.anular = false
    } else if (accion === 'VALIDACION ACEPTAR') {
      dialogoMsg.value.validacion = false
    }
  }

  const guardar = (tipo, dialogoMsg, isPrefix) => {
    resultado.value.data = null
    request.value.tipo = tipo
    fnHttpToken('POST', resourceRouter, { form: form.value }, dialogoMsg, isPrefix)
  }

  const modificar = (dialogoMsg, isPrefix) => {
    resultado.value.data = null
    request.value.tipo = 'GUARDAR'
    fnHttpToken('PUT', resourceRouter + '/' + formId.value.id, { form: form.value }, dialogoMsg, isPrefix)
  }

  const anular = (dialogoMsg, isPrefix) => {
    resultado.value.data = null
    request.value.tipo = 'ANULAR'
    fnHttpToken('DELETE', resourceRouter + '/' + formId.value.id, null, dialogoMsg, isPrefix)
  }

  const fnMensajesCustomer = (metodo, pResourceRouter, accion, dialogoMsg, pForm, isPrefix) => {
    if (accion === 'PREGUNTAR ACEPTAR') {
      dialogoMsg.value.preguntar = false
      guardarCustomer(metodo, pResourceRouter, dialogoMsg, pForm, isPrefix)
    } else if (accion === 'PREGUNTAR CANCELAR') {
      dialogoMsg.value.preguntar = false
    }
  }

  const guardarCustomer = (metodo, pResourceRouter, dialogoMsg, pForm, isPrefix) => {
    resultado.value.data = null
    request.value.tipo = 'GUARDAR'
    fnHttpToken(metodo, pResourceRouter, { form: pForm }, dialogoMsg, isPrefix)
  }

  watch(request.value, (newValue, preValue) => {
    if (request.value.status === 3 && request.value.data !== null) {
      if (request.value.tipo === 'MODELOS') {
        modelos.value.data = request.value.data
      }

      if (request.value.tipo === 'MODELO') {
        modelo.value.data = request.value.data
      }

      if (request.value.tipo === 'GUARDAR') {
        if (request.value.data.status === 1) {
          resultado.value.data = request.value.data.data
          fnSuccess('DATOS GUARDADOS', 'top')
        } else {
          fnError('ERROR AL GUARDAR', 'top')
        }
      }

      if (request.value.tipo === 'GUARDAR SIN MENSAJE') {
        if (request.value.data.status === 1) {
          resultado.value.data = request.value.data.data
        } else {
          fnError('ERROR AL GUARDAR', 'top')
        }
      }

      if (request.value.tipo === 'GUARDAR - CONSECUTIVO') {
        if (request.value.data.status === 1) {
          resultado.value.data = request.value.data.data
          // COLOCAR DIALOGO CONSECUTIVO
          dialogoMsg.value.preguntarConsecutivo = false
          dialogoMsg.value.data = request.value.data.data
        } else {
          fnError('ERROR AL GUARDAR', 'top')
        }
      }

      if (request.value.tipo === 'ANULAR') {
        if (request.value.data.status === 1) {
          resultado.value.data = request.value.data.data
          fnSuccess('DATOS ANULADOS', 'top')
        } else {
          fnError('ERROR NO SE PUDO ANUALAR', 'top')
        }
      }

      if (request.value.tipo === 'FILES') {
        if (request.value.data.status === 1) {
          files.value.files = request.value.data.files
          files.value.data = request.value.data.data
          files.value.duplicados = request.value.data.duplicados
          uploads.value.data = []
          uploads.value.progress = 0
        }
      }

      if (request.value.tipo === 'FILE REMOVER') {
        files.value.files = request.value.data.files
        files.value.data = request.value.data.data
        files.value.duplicados = request.value.data.duplicados
      }

      if (request.value.tipo === 'ERROR VALIDACION') {
        dialogoMsg.value.data = request.value.data
        dialogoMsg.value.validate = request.value.validate
        dialogoMsg.value.validacion = true
      }
      fnInicializarRequest()
    }
    // -------
    if (request.value.error) {
      const error = request.value.error
      // ✅ Si hay respuesta del servidor
      if (error.response) {
        if (error.response.status === 401) {
          const token = { accessToken: { id: 0 }, plainTextToken: '' }
          store.setPrefix('')
          store.setUser(null)
          store.setToken(token)
          router.push({ path: '/', replace: true })
        }
      // ✅ Si la petición fue cancelada o abortada
      } else if (error.code === 'ECONNABORTED') {
        console.log('La petición fue abortada o cancelada')
      // ✅ Otros errores (red, DNS, etc)
      } else {
        console.log('Error de red u otro tipo:', error.message)
      }
    }
    // -------
  })

  return { fnAll, fnId, fnModel, fnModels, fnCustomer, fnDownload, fnDownloadContent, fnUpload, fnDownloadContentFile, fnUploadCustomer, fnFileRemover, fnValidar, fnSinValidar, fnSinPreguntar, fnMensajes, fnMensajesCustomer, myForm, modelos, modelo, objectoForm, resultado, uploads, files }
}
